<template>
<div class="order-wrapper">
  <portal to="root">
    <navigation-bar />
  </portal>

  <!-- Wide -->
  <div class="order-wide">
    <div class="column">
      <br>

      <image-preview />

      <br>

      <unit-count v-model="quantity" />
      <el-button
        :margin-top="true"
        @click="order"
        style="height: 50px; font-size: 18px; text-align: center; align-content: center; font-weight: 700; margin-top: 20px; justify-content: center;"
        >{{ __('Next') }}</el-button>

      <br><br>
      <b>{{ __('Coupon code') }}:</b>
      <coupon-code />

    </div>
    <div class="column">
      <h1>HeadQ</h1>
      <pricing-preview />

      <br><br>
      <info-summary />
    </div>
  </div>

  <!-- Narrow -->
  <div class="order-narrow">
    <h1>HeadQ</h1>
    <image-preview />
    <pricing-preview />

    <br><br>

    <unit-count v-model="quantity" />
    <el-button
      :margin-top="true"
      @click="order"
      style="height: 50px; font-size: 18px; text-align: center; align-content: center; font-weight: 700; margin-top: 20px; justify-content: center; width: 100%;"
      >{{ __('Next') }}</el-button>

    <br><br>

    <b>{{ __('Coupon code') }}:</b><br>
    <coupon-code />

    <br><br><br>
    <info-summary />

    <br><br><br><br><br><br>
  </div>

  <div class="orderPage__footer">
    <info-footer />
  </div>
</div>
</template>
<script>

import NavigationBar from '@/components/NavigationBar.vue'
import UnitCount from 'components/elements/UnitCount.vue'
import InfoSummary from 'components/orderPage/InfoSummary.vue'
import ImagePreview from 'components/orderPage/ImagePreview.vue'
import PricingPreview from 'components/orderPage/PricingPreview.vue'
import CouponCode from 'components/orderPage/CouponCode.vue'
import InfoFooter from '@/components/landingPage/InfoFooter.vue'
import { mapGetters } from 'vuex'
import analytics from 'services/analytics.js'

import logScope from 'log-scope'
const log = logScope('orderPage')

export default {
  name: 'OrderPage',
  components: { NavigationBar, UnitCount, InfoSummary, ImagePreview, PricingPreview, CouponCode, InfoFooter },
  mounted () {
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })

    // Coupon code from params
    const code = this.$route.params.code || ''
    if (code && typeof code === 'string' && code !== '') {
      log.debug('Coupon code from param: ' + code)
      this.$store.commit('couponCode', code)
      this.$store.dispatch('checkCouponCode')
    }

    const partner = this.$route.params.partner || ''
    if (partner && typeof partner === 'string' && partner !== '') {
      log.success('Partner code from param: ' + partner)
      this.$store.commit('partnerCode', partner)
    }
  },
  computed: {
    ...mapGetters(['couponCode']),
    quantity: {
      get () {
        return this.$store.getters.quantity
      },
      set (value) {
        this.$store.commit('quantity', value)
      }
    }
  },
  methods: {
    order () {
      analytics.log('addToCart')
      this.$router.push({ name: 'CheckoutPage' })
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../style/variables.less';

  .order-wrapper {
    background-color: #ffffff;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 100%;
    height: auto;
    width: 100%;
    padding-bottom: 150px;
    padding-top: 50px;

    @media (max-width: 800px) {
      padding: 50px 0px;
      height: auto;
      min-height: 100%;
    }
  }

  .order-wide {
    max-width: 100%;
    width: auto;
    height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap-reverse;

    @media (max-width: 800px) {
      display: none;
    }
  }

  .order-narrow {
    max-width: 100%;
    width: 400px;
    height: auto;
    display: flex;
    align-self: center;
    justify-content: flex-start;
    flex-direction: column;
    display: none;
    padding: 0px 15px;
    box-sizing: border-box;

    @media (max-width: 800px) {
      display: block;
    }
  }

  .column {
    margin: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 380px;
    max-width: 100%;
    box-sizing: border-box;
    padding: 50px 30px;

    @media (max-width: 600px) {
      padding: 0px
    }
  }

  .coupon-code {
    border-radius: 5px;
    border: none;
    box-sizing: border-box;
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.2);
    height: 50px;
    padding-left: 20px;
    width: 100%;
  }

  .orderPage__footer {
    width: 100%;
    position: absolute;
    bottom: 0px;
  }
</style>
